export const MFA_CODE_LENGTH = 6;

/** How long the "enabled" confirmation stays up before the app takes over. */
export const MFA_SUCCESS_HOLD_MS = 2000;

export const RECOVERY_CODES_FILE_NAME = 'diagnocat-recovery-codes.txt';

export const QR_CODE_SIZE = 148;
